<template>
  <div class="myWallet">
    <!--钱 -->
    <div class="money">
      <div class="balanceInfo" @click="balanceDetail">
        <label>余额明细</label>
      </div>
      <div style="clear: both;"></div>
      <span class="payInfo">¥{{$moneyFormat.RMB(balance)}}</span>
      <p></p>
      <span>账户余额</span>
    </div>
    <!--功能 -->
    <div class="function">
      <van-grid :column-num="4" icon-size="40" :border='false'>
        <van-grid-item   icon="gold-coin" text="充值" @click="pay" />
         <van-grid-item   icon="coupon" text="优惠券" @click="goCouponPage" />
      </van-grid>
    </div>
    <div class="advertising" style="margin: 3%" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="100%" />
    </div>
    <!-- <van-popup v-model="dialog" closeable style="width: 90%;background: transparent;">
      <div style="position: relative;">
        <van-image :src="$api.newYearActivityImage" @click="pay" />
        <div style="margin-left: 40%;">
          <div style="float: left;position: absolute;bottom: 13%;width: 20%;text-align: center; height: 8%;" @click="hd">
          </div>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    name: "appeal",
    data() {
      return {
        dialog: true,
        url: "", //展示图片
        cUrl: "", //点击跳转地址
        type: 0, //0 拍照 1申诉
        balance: 0.00,
        cz: "../static/img/cz.png",
        openid: "",
        userId: ""
      };
    },
    methods: {
      pay() {
        this.$router.push({
          path: "/walletPay",
          query: {
            "userId": this.userId
          }
        });
      },
      goCouponPage(){
        this.$router.push({
          path: "/myCoupon",
          query: {
            "userId": this.userId
          }
        });
      },
      hd() {
        window.location.href = this.$api.newYearInfoUrl;
      },
      getWallet() {
        this.$http.post(this.$api.myWallet + "/" + this.openid, {}).then(res => {
          this.balance = res.data.balanceRecharge;
          this.userId = res.data.appUserId;
        });
      },
      balanceDetail() {
        this.$router.push({
          path: "/detail",
          query: {
            "userId": this.userId
          }
        });
      },
      getopenId() {
        if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "") {
          this.openid = mySessionStorage.getItem("openid");
          this.getWallet();
        } else {
          this.$getOpenid().then(res => {
            this.openid = mySessionStorage.getItem("openid");
            console.log("--------------------------", this.openid);
            this.getWallet();
          });
        }
      },

      //广告加载
      getAdvertisingInfo() {
        this.$axios({
            url: this.$api.receipt,
            method: "get",
          })
          .then(res => {
            this.url = res.data.data.creativeImg.creativeUrl;
            this.cUrl = res.data.data.landingPage;
            let trackUrl = res.data.data.trackUrl;
            this.$axios({
              url: trackUrl,
              method: "get",
            }).then(res => {
              console.log(res)
            });
            console.log(res.data);
          })
      },
      clickUrl() {
        window.location.href = this.cUrl;
      },
      // 点击空白关闭弹窗
      handleClose(done) {
        done();
      },
    },
    created() {},
    mounted() {
      //mySessionStorage.setItem("openid", "oiuZN6Kj5VB2kiu7ytOWdoznct_Q");
      this.getAdvertisingInfo();
      this.getopenId();
    }
  };
</script>

<style scoped>
  .myWallet {
    background-color: #F0F0F0;
    height: 100%;
    width: 100%;
    padding-top: 1px;
    overflow-y: scroll;
  }

  .money {
    text-align: center;
    background: white;
    height: 25%;
    margin: 3%;
  }

  .money .balanceInfo {
    float: right;
    padding: 10px;
    position: relative;
  }

  .money .payInfo {
    font-size: 20px;
    font-weight: bolder;
    position: relative;
    color: red;
  }

  .function {
    background: white;
    height: auto;
    margin: 3%;
  }

  .funDiv {
    text-align: center;
    width: 15%;
    height: 60%;
    padding: 1% 3%;
    float: left;
    margin: 3% 0;
  }

  .funDiv label {
    font-size: 14px;
  }

  .funDiv .img {
    width: 80%;
    height: 70%;
    background-color: orangered;
    padding: 10%;
    border-radius: 50%;
  }

  .funDiv img {
    width: 100%;
    height: 95%;
  }

  .gg {
    margin: 3%;
    height: 25%;
  }

  .gg img {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/wallet/myWallet.vue